import React from 'react'
import Messenger from '../Layout/Messenger'

const MessengerPage = () => {
  return <Messenger />
}

export default MessengerPage
